import { render, staticRenderFns } from "./StallionPlanCuve.vue?vue&type=template&id=2a61014c&"
import script from "./StallionPlanCuve.vue?vue&type=script&lang=js&"
export * from "./StallionPlanCuve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports